import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toggleFooter } from '@avalara/bat-apps-shared/client/helpers/index';
import { setCurrentOfferPage } from '../../store/offer';
import { pollForOfferPlan } from '../../lib/side-effects/polling';
import { selectState } from '../../selectors';
import { getEsbConfig } from '../../selectors/esb';
import { isEmbeddedSelector } from '../../selectors/offer';
import { setShowingLoadingRocket } from '../../store/data';
import LoadingRocket from '../loading-rocket';
import { Pages } from '../../../shared/types/offers';
const SettingUp = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isEsbTrialAddOn = useSelector(getEsbConfig) != null;
    const { offer: { provisioningDelayed, offerFlow }, order: { selectedPlanName }, } = useSelector(selectState);
    const isEmbedded = useSelector(isEmbeddedSelector);
    useEffect(() => {
        dispatch(setShowingLoadingRocket(true));
        return () => { dispatch(setShowingLoadingRocket(false)); };
    }, []);
    useEffect(() => {
        if (!offerFlow)
            return;
        dispatch(setCurrentOfferPage(Pages.SettingUp));
        if (selectedPlanName)
            dispatch(pollForOfferPlan(offerFlow, selectedPlanName, history));
    }, [offerFlow]);
    useEffect(() => {
        if (provisioningDelayed && isEmbedded) {
            const footer = document.querySelector('aui-footer');
            if (footer) {
                footer.className = '';
            }
        }
    }, [provisioningDelayed, isEmbedded]);
    let heading;
    if (provisioningDelayed) {
        heading = 'Setup is taking longer than usual';
    }
    else {
        heading = "We're getting you set up";
    }
    const subheading = (() => {
        if (isEsbTrialAddOn)
            return 'Stay on the page—this can take up to three minutes.';
        if (provisioningDelayed) {
            return (React.createElement("span", null,
                "Stay on the page a couple more minutes, and if the problem ",
                "doesn't",
                " resolve,",
                React.createElement("button", { className: 'pad-all-none pad-left-xs ghost-blue', onClick: toggleFooter }, "contact your account manager")));
        }
        return 'This only takes a minute or so';
    })();
    return React.createElement("div", { className: 'text-center' },
        React.createElement("div", { className: 'pad-top-sm pad-bottom-lg' },
            React.createElement("h1", { className: 'margin-bottom-sm' }, heading),
            React.createElement("p", { className: 'margin-bottom-sm' }, subheading),
            isEsbTrialAddOn &&
                React.createElement("p", null, "When we're done, you'll go to Avalara.")),
        React.createElement(LoadingRocket, null));
};
export default SettingUp;
